$('.announcement-bar').slick({
    dots: false,
    arrows: true,
    infinite: false,
    autoplay:true,
    infinite: true,
    pauseOnHover: false,
    pauseOnFocus: false,
    speed: 1300,
    prevArrow: '<button class="slide-arrow prev-arrow"><img class="announcement_arrow" class="chevron_right" src="https://cdn.shopify.com/s/files/1/0627/9548/1257/t/2/assets/chevron-gray-left.png?v=160868268384156994941673347940"/></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><img class="announcement_arrow" class="chevron_right" src="https://cdn.shopify.com/s/files/1/0627/9548/1257/t/2/assets/chevron-gray-right.png?v=126369169272363568681673348871"/></button>'
   
 
  
});
$('.sign__up').on('click',function(){
  //  document.getElementById("shopify-section-footer").scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});

    $([document.documentElement, document.body]).animate({
    scrollTop: $("#shopify-section-footer").offset().top
      }, 2000);

})
